import React, { Component } from "react";

import LoadingDialog from "./LoadingDialog";
import ErrorDialog from "./ErrorDialog";

import icon_upload from "../resources/upload_white.png";

var request = require("../../utilities/NetworkRequest");

export default class UploadMigrationDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      is_loading: false,
      body_error: {
        is_show: false,
        message: "",
      },
      upload_file: null,
    };
  }

  showErrorDialog(body) {
    if (body.is_show) {
      return (
        <ErrorDialog
          body_error={body}
          onCloseDialog={() =>
            this.setState({ body_error: { is_show: false, message: "" } })
          }
        />
      );
    } else {
      return null;
    }
  }

  onSelectedFile(event) {
    this.setState({ upload_file: event.target.files[0] });
  }

  onUploadClicked(position) {
    let temp_error;
    if (this.state.upload_file === null) {
      temp_error = this.state.body_error;
      temp_error.is_show = !temp_error.is_show;
      temp_error.message = "Anda belum memilih file yang akan diunggah!";
      this.setState({ body_error: temp_error });
    } else {
      this.postBatchUpdate();
    }
  }

  postBatchUpdate() {
    this.setState(
      {
        is_loading: !this.state.is_loading,
      },
      () => {
        let data_form = new FormData();
        data_form.append("upload_file", this.state.upload_file);
        request.onRequestForm(
          1,
          "/upload/migration_cb_template",
          data_form,
          function(res_data) {
            if (res_data.code === 1) {
              this.setState({ is_loading: false });
              this.props.onCloseListener("next");
            } else {
              let temp_error = this.state.body_error;
              temp_error.is_show = !temp_error.is_show;
              temp_error.message = res_data.message;
              this.setState({
                upload_file: null,
                body_error: temp_error,
                is_loading: false,
              });
            }
          }.bind(this)
        );
      }
    );
  }

  render() {
    return (
      <div
        onClick={(e) => this.props.onCloseListener("close")}
        className="process_dialog_root layer_a"
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className="process_dialog_container_b"
        >
          <LoadingDialog showDialog={this.state.is_loading} />
          {this.showErrorDialog(this.state.body_error)}
          <div className="default_text_medium_gray bold_text">
            <span>UPLOAD MIGRATION CB</span>
          </div>
          <div className="upload_root">
            <div className="upload_content normal_padding_top">
              <div className="upload_input_wrapper">
                <div className="normal_padding_bottom default_text_normal_gray_b bold_text">
                  <u>UPLOAD PERUBAHAN DATA CB</u>
                </div>
                <input
                  //   key={data[i].action + "_" + data[i].key}
                  className="default_text_normal_gray"
                  onChange={(event) => this.onSelectedFile(event)}
                  type="file"
                  accept=".xls, .xlsx"
                />
              </div>
              <div
                onClick={this.onUploadClicked.bind(this)}
                className="default_text_normal_white_b orange_background upload_button"
              >
                <img className="mini_image_c" src={icon_upload} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
